var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedproposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 43.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#425eab;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,4.69,4.69,23.43H45.31L37.5,4.69ZM0,30.46V23.65a4.67,4.67,0,0,1,.35-2L8.58,1.92A3.12,3.12,0,0,1,11.46,0H38.54a3.12,3.12,0,0,1,2.88,1.92l8.22,19.71a4.7,4.7,0,0,1-2.53,6.13,4.63,4.63,0,0,1-1.8.36H4.69v2.34a.78.78,0,0,0,.78.79H43a2.34,2.34,0,0,1,0,4.68h-32v2.35a.78.78,0,0,0,.78.78H38.28a2.34,2.34,0,0,1,0,4.68H11.72a5.46,5.46,0,0,1-5.47-5.46V35.93H5.47A5.46,5.46,0,0,1,0,30.46H0M32.13,12.59a2.35,2.35,0,0,0-3.2-3.43l-.12.12-5.37,5.37L21.19,12.4a2.35,2.35,0,0,0-3.43,3.2l.12.12,3.9,3.9a2.34,2.34,0,0,0,3.32,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedproposal);
export default __webpack_public_path__ + "static/media/closed proposal.885951dfd14502c1062c4ced53bd5654.svg";
export { ForwardRef as ReactComponent };